export default __webpack_public_path__ + "static/media/footer-background.c3c2cd80.svg";